import { SelectOption } from "@/service/common/entity/SelectOption";
import { cooperationModeEnum } from "@/service/supplier-meta/enums/cooperationModeEnum";
export interface CooperationModeOption extends SelectOption {
  value: number;
  paymentType: number | null;
}
export const cooperationModeOptions: CooperationModeOption[] = [
  {
    label: "常规采销",
    value: cooperationModeEnum.常规采销,
    paymentType: null,
  },
  {
    label: "一件代发",
    value: cooperationModeEnum.一件代发,
    paymentType: null,
  },
  {
    label: "代销",
    value: cooperationModeEnum.代销,
    paymentType: null,
  },
];
